import { message } from 'antd';
import { Authenticate, appendSearchParams, getParameter, removeSearchParams, tokenManager } from 'eastedu-login-sdk';
import React from 'react';

const isLocalhost = (url: string) => {
  return /^(https?:)?\/\/localhost/.test(url);
};

function getBlankUrl(token: { access_token?: string; uid?: string }) {
  const searchParams = new URLSearchParams(location.search);
  searchParams.set('token', token.access_token || '');
  searchParams.set('userId', token.uid || '');
  return `/blank?${searchParams.toString()}`;
}

function OAuthLogin(props: any) {
  // 如果是本地环境，则从url中获取token。
  if (isLocalhost(location.href)) {
    const token = getParameter('token');
    if (token) {
      try {
        const tokenInfo = JSON.parse(decodeURIComponent(token));
        tokenManager.setToken(tokenInfo);
        window.location.href = getBlankUrl(tokenInfo);
        // location.href = removeSearchParams(location.href, ['token']);
      } catch (error) {
        console.error(error);
      }
    }
  }

  return (
    <Authenticate
      onAuthenticated={async (token, returnUri) => {
        if (returnUri && isLocalhost(returnUri)) {
          location.href = appendSearchParams(returnUri, {
            token: encodeURIComponent(JSON.stringify(token)),
          });
          // window.location.href = `http://localhost:8000/blank?token=${token.access_token}&userId=${token.uid}`;
        } else {
          // window.location.href = `/blank?token=${token.access_token}&userId=${token.uid}&refreshToken=${token.refresh_token}`;
          // 这里不传refreshToken，因为refreshToken在blank页面的url中获取，可能造成刷新token失败。
          // 此处的token是从cookies中获取的，不一定是有效的token.
          window.location.href = `/blank?token=${token.access_token}&userId=${token.uid}`;
        }
      }}
      onError={(err, logout) => {
        message.error(err.message ?? '获取用户信息失败，请重新登录', 3, () => {
          logout();
        });
      }}
    />
  );
}

export default OAuthLogin;
